import React from 'react';
import { Link } from 'react-router-dom';

export const bannerInfo = {
  heading: "Made by Accountants and Tax professionals for your success",
  peragraph: "Get the legal help you need, with our DIY services or attorney advice. Either way, we've got your back.",
  button: "Contact us"
}

export const businessType = [
  { url: "/llc_packge", type: "Limited liability company (LLC)", pera: "A flexible business structure offering personal liability protection for owners' assets.", button: "Register LLC" },
  { url: "/business_name_corpo", type: "Corporation", pera: "A separate legal entity, offering owners protection and growth opportunities.", button: "Register Corporation" },
  { url: "", type: "Doing business as (DBA)", pera: "Run your business with a cooler name with your current entity.", button: "Register DBA" },
]


export const businessTypes = [
  {
    id: 1,
    name: "LLC", typeList: [
      { listName: "Owners are called members", tooltip: "In an LLC, the people who own business are known as members. They can be individuals, other companies, or even foriegn entities. " },
      { listName: "Flexible management structure", tooltip: "LLCs can be managed by their members or by managers who are appointed by the members, allowing for more flexibility in how the business is run." },
      { listName: "Pass-through taxation by default", tooltip: "The LLC itself doesn't pay taxes. Instead, profits and losses pass through to the members, who report them on their personaltax returns, avoiding double taxation." },
      { listName: "Limited personal liability", tooltip: "Members of an LLC are not personally responsible for the company's debts or liabilities. Their risk is limited to what they've invested in the business." },
      { listName: "Few formalities and regulations", tooltip: "LLCs are generally easier to set up and operate, with fewer legal requirements and administrative tasks compared to operations. " },
    ],
    states: [
      // { name: "Alabama" },
      // { name: "Delaware" },
      // { name: "Indiana" },
      // { name: "Kansas" },
      { name: "Michigan" },
    ]
  },
  {
    id: 2,
    name: "Corporation", typeList: [
      { listName: "Owners are called shareholders", tooltip: "In a corporation, the people who own shares of the company are called shareholders. They own a portion of the company based on the number of shares they hold." },
      { listName: "Formal management structure with directors and officers", tooltip: "Corporations have a more rigid structure, with a board of directors overseeing major decisions and officers (like a CEO) managing day-to-day operations." },
      { listName: "Subject to double taxation (unless S-Corp)", tooltip: "Corporations pay taxes on their profits, and shareholders also pay taxes on dividends they receive, resulting in taxation at both the corporate and personal levels. S-Corporations can avoid this by passing income directly to shareholders." },
      { listName: "Limited personal liablity", tooltip: "Shareholders are not personally liable for the cororation's debts or legal issues. Their financial risk is limited to their investment in the corporation. " },
      { listName: "More formalities and regulatory requirements", tooltip: "Corporation must follow stricter rules, including holding regular meetings, maintaining detailed records, and complying with various reporting requirements." },
    ],

    states: [
      // { name: "Alabama" },
      // { name: "Delaware" },
      // { name: "Indiana" },
      // { name: "Kansas" },
      { name: "Michigan" },

    ]

  },
  {
    id: 3,
    name: "BOIR", typeList: [
      { listName: "Owners are called members" },
      { listName: "Flexible management structure" },
      { listName: "Pass-through taxation by default" },
      { listName: "Limited personal liability" },
      { listName: "Few formalities and regulations" },
    ],



    states: [
      // { name: "Alabama" },
      // { name: "Delaware" },
      // { name: "Indiana" },
      // { name: "Kansas" },
      { name: "Michigan" },

    ]

  }
]

export const missionStatement = [
  {
    id: 1,
    type: "Our Vision",
    description:
      "Our vision is to become the leading provider of business formation and compliance services, known for our innovative solutions, exceptional customer service, and commitment to helping businesses thrive. We strive to create a supportive and dynamic environment where entrepreneurs can achieve their dreams and make a positive impact on their communities.",
  },
  {
    id: 2,
    type: "Join Us",
    description:
      "Whether you are starting your first business or looking to expand your existing enterprise, Oktobiz is here to support you every step of the way. Join us in simplifying business and amplifying success. Contact us today to learn more about our services and how we can help you achieve your business goals",
  },
];


export const offers = [
  {
    id: 1,
    heading: "Business Formation : ",
    description:
      "We specialize in forming LLCs and Corporations, providing all necessary documentation and guidance to ensure a smooth setup.",
  },
  {
    id: 2,
    heading: "BOI Compliance : ",
    description:
      "Our compliance services ensure your business adheres to Beneficial Ownership Information (BOI) regulations, promoting transparency and legal compliance.",
  },
  {
    id: 3,
    heading: "EIN Acquisition : ",
    description:
      "We help you obtain your Employer Identification Number (EIN), essential for opening a business bank account and hiring employees.",
  },
  {
    id: 4,
    heading: "Licensing and Permits : ",
    description:
      "We assist in identifying and obtaining the necessary licenses and permits required for your business operations, ensuring you meet all regulatory requirements.",
  },
  {
    id: 5,
    heading: "Additional Services : ",
    description:
      " As we grow, we plan to expand our offerings to include bookkeeping, e-filing taxes, legal document generation, payroll software, and tax preparation tools.",
  },
];

export const howWork = [
  {
    img: "Assets/formation.webp", name: "Formation", pera: "Form your LLC or Corporation and get your EIN", typeList: [
      { list: "Our intuitive platform will guide you through the process. " },
      { list: "We also help you obtain your EIN which is essential for banking and licensing." }
    ]
  },
  {
    img: "Assets/business-c.webp", name: "Compliance", pera: "Ensure Compliance with BOI filing", typeList: [
      { list: "Stay compliant by filing your Beneficial Ownership Information (BOI). " },
      { list: "We make sure you meet all necessary regulatory requirements, avoiding potentioal penalties. " }
    ]
  },
  {
    img: "Assets/certification.webp", name: "Licensing", pera: "Get in touch with Oktobiz for ongoing guidance and Licensing", typeList: [
      { list: "Once your business is set up, contact Oktobiz for continuous support. " },
      { list: "We provide guidance on additional licensing requirements and offer continuous support to help you manage and grow effectively. " }
    ]
  }


]

export const whyChoose = [
  { name: "Expert Support", number: "01", pera: "Our team of experts is dedicated to providing you with the support and guidance you need at every step of your business journey." },
  { name: "Affordable Solutions", number: "02", pera: "We believe that quality business services should be accessible to everyone. Our competitive pricing ensures you get the best value for your investment." },
  { name: "Easy Process", number: "03", pera: "We simplify complex legal and administrative processes, making it easy for you to start and manage your business with confidence." },
  { name: "Customer Satisfaction", number: "04", pera: "Your success is our priority. We are committed to delivering exceptional service and building long-term relationships with our clients." },

]

export const llcPackage = [
  { package: "StartRight", price: "$0", pera: "Set the groundwork for your dreams with a solid start", button: "Register LLC", icon: "Assets/LLC_img/keyhole.png" },
  { package: "BizBoost", price: "$199", pera: "Fuel your dreams and move your business forward", button: "Register LLC", icon: "Assets/LLC_img/diagram.png" },
  { package: "EntityElite", price: "$349", pera: "Reach new heights! ascend to success with eas", button: "Register LLC", icon: "Assets/LLC_img/mountains.png" },

]
export const list_items = [
  { name: "UNLIMITED business name search" },
  { name: "Articles of organization or incorporation" },
  { name: "FREE Registered Agent service for the first year" },
  { name: "Lifetime support" }
]



export const llcComplian = [
  { icon: "fa-solid fa-envelope", title: "Registered Agent", pera: "Required by the Secretary of State to receive physical legal notices and official mail during business hours." },
  { icon: "fa-solid fa-file-lines", title: "Essential Documents", pera: "Required by the Secretary of State to receive physical legal notices and official mail during business hours." },
  // { icon: "fa-regular fa-file-lines", title: "Business Filings & Licenses", pera: "Required by the Secretary of State to receive physical legal notices and official mail during business hours." },
]

export const corpoHelp = [
  { icon: "fa-solid fa-shop", title: "Tell us about your business", pera: "Answer a few questions to help us get to know you and make sure you set up your corporation correctly" },
  { icon: "fa-regular fa-user", title: "See your personalized offers", pera: "Based on your answers and our 20+ years of experience, you’ll see offers tailored to your unique business." },
  { icon: "fa-regular fa-circle-check", title: "Form with total peace of mind", pera: "Let us take care of the legal documents and ongoing requirements so you can focus on building your business" },
]

export const legalComplaint = [
  { icon: "fa-regular fa-envelope", title: "Registered Agent", pera: "Most states require an agent to receive legal notices." },
  { icon: "fa-solid fa-file-invoice", title: "Essential Documents", pera: "Corporations often need specific docs and licenses to operate." },
  { icon: "fa-regular fa-circle-check", title: "Total Compliance", pera: "Keep your business in good standing to protect your personal assets." },
]

export const totalComplaint = [
  { icon: "fa-regular fa-circle-check", title: "Risk", pera: "Fail to stay compliant and you can be sued personally for acts of your business." },
  { icon: "fa-regular fa-circle-check", title: "We've got your back", pera: "We help you set-up and stay compliant, taking care of annual report filings." },
  { icon: "fa-regular fa-circle-check", title: "Peace of mind", pera: "If we miss anything, we pay the fine or penalty." },
]

export const registerAgent = [
  { title: "Legally required", pera: "You are legally required to have a registered agent." },
  { title: "Easy choice", pera: "We provide this for the vast majority of our LLCs." },
  { title: "Great value", pera: "No fees until your documents are submitted to the state. Just $199 for first year + renews annually. Great value!" },
]
export const registerAgentCorpo = [
  { title: "Legally required", pera: "You are legally required to have a registered agent." },
  { title: "Easy choice", pera: "We provide this for the vast majority of our Corporations." },
  { title: "Great value", pera: "No fees until your documents are submitted to the state. Just $249 for first year + renews annually. Great value!" },
]


export const agreement = [
  { title: "Operating Agreement ", price: "$99", pera: "An operating agreement is your company’s constitution. Set guidelines, settle disputes,  and protect your assets." },
  { title: "Operating Agreement plus EIN ", price: "$159", pera: "An operating agreement is your company’s  constitution. Set guidelines, settle disputes, and protect your assets." },
  { title: "Operating Agreement, EIN, Legal Forms & eSign", price: "$199", pera: "An operating agreement is your company’s constitution. Set guidelines, settle disputes,  and protect your assets." },
]


export const agreementCorpo = [
  { title: "Bylaws & resolutions ", price: "$99", pera: "Bylaws serve as a corporation’s constitution and its resolutions document its first major decisions" },
  { title: "Bylaws & resolutions plus EIN", price: "$159", pera: "An EIN is like your corporation’s Social Security number. Use it to file taxes, build your staff, and access financial resources." },
  { title: "Bylaws & resolutions, EIN, plus Licenses", price: "$199", pera: "Licenses keep your business compliant and running smoothly. Ensure you have what’s required for your specific industry and state." },
]

export const packages = [
  { title: "Economy ", price: "$149", pera: "Oktobiz standard processing time*+ free website with Inc formation" },
  { title: "Standard", price: "$329", pera: "Includes Economy package +Founder's kit with personalized notebook" },
  { title: "Express Gold", price: "$349", pera: "Includes Standard package +fastest processing speed" },
]

// export const found = [
//   {head:"Expedited Processing" pera:"Total turnaround times to form your business vary and can take several weeks—but you can upgrade to expedited LegalZoom processing to get your business formed faster.*",
//     prices:[

//     ]
//   }
// ]

export const taxDocument = [
  { title: "Tax advisory", hpara: "Best for new businesses seeking advice only", bpara: "Unlimited advice from tax experts to set your business up for success.", price: "$49", priceType: "Billed monthly" },
  { title: "Complex Tax Return", hpara: "Besr for partnerships, S corps and C corps", bpara: "Prep and filing the corporation or partnership tax returns. Unlimited expert device. Plus free LZ Books.", price: "$119", priceType: "Annaul plan billed monthly" }
]


export const llcFormation = [
  { id: 1, title: "Step-by-Step Guidance:", para: "Our platform walks you through each step, providing clear instructions and support." },
  { id: 2, title: "State-Specific Requirements:", para: "We tailor our service to meet the specific regulations of your state, ensuring full compliance." },
  { id: 3, title: "Affordable Packages:", para: "Choose from our competitive pricing plans to find the best fit for your needs." }
]

export const employerIdNum = [
  { id: 1, title: "Quick and Easy Application: ", para: "We streamline the process of applying for an EIN with the IRS." },
  { id: 2, title: "Integration with Formation Services: ", para: "Add EIN acquisition to your LLC or Corporation formation package for a seamless setup." },
  { id: 3, title: "Essential for Financial Operations: ", para: "Understand the importance of an EIN for your business's financial activities" }
]

export const faqs = [
  { id: 1, title: "What is an LLC?", para: "An LLC (Limited Liability Company) is a business structure that offers personal liability protection and flexible tax options." },
  { id: 2, title: "How long does it take to form an LLC?", para: "It usually takes 5-10 business days, but this can vary by state." }
]

export const pricing = [
  { id: 1, title: "Basic Package:", heading: "plus state filing fees", para: "Articles of Organization", price: "$99", button: "Get Started" },
  { id: 2, title: "Standard Package:", heading: "plus state filing fees", para: "Articles of Organization plus EIN and legal documents ", price: "$150", button: "Get Started" },
  { id: 3, title: "Premium Package:", heading: "plus state filing fees", para: "Articles of Organization, EIN and legal documents, BOI, Licensing support", price: "$250", button: "Get Started" },
]

export const corpoFormation = [
  { id: 1, title: "Step-by-Step Guidance: ", para: "We simplify the process, helping you understand and complete all necessary steps." },
  { id: 2, title: "Preparation and Filing of Documents: ", para: "We manage the filing of Articles of Incorporation and other essential documents." },
  { id: 3, title: "Corporate Bylaws: ", para: "Draft comprehensive bylaws to govern your Corporation's operations." },
  { id: 4, title: "State Compliance: ", para: "Ensure your Corporation meets all state-specific regulations and reporting requirements." }
]


export const faqsCorporation = [
  { id: 1, title: "What is a Corporation?", para: "A Corporation is a legal entity that is separate from its owners, providing limited liability protection and allowing the issuance of stock." },
  { id: 2, title: "How long does it take to form a Corporation?", para: "The process typically takes 5-10 business days, depending on the state." }
]


export const pricingCorporation = [
  { id: 1, title: "Basic Package:", heading: "plus state filing fees", para: "Articles of Incorporation", price: "$99", button: "Get Started" },
  { id: 2, title: "Standard Package:", heading: "plus state filing fees", para: "Articles of Incorporation plus EIN and legal documents", price: "$150", button: "Get Started" },
  { id: 3, title: "Premium Package:", heading: "plus state filing fees", para: "Articles of Incorporation, EIN and legal documents, BOI, Licensing support", price: "$250", button: "Get Started" },
]


export const compliance = [
  { id: 1, title: "Regulatory Compliance: ", para: "We help you understand and meet BOI filing requirements, ensuring you remain compliant with federal regulations." },
  { id: 2, title: "Timely Filing: ", para: "Avoid late penalties with our timely filing reminders and submission services." },
  { id: 3, title: "Expert Assistance: ", para: "Receive support from compliance specialists who can answer your questions and provide guidance throughout the process." },
]

export const licensingAndGuidance = [
  { id: 1, title: "Personalized Advice: ", para: "Get tailored advice from business experts who understand your unique needs." },
  { id: 2, title: "Continual Support: ", para: "Access our team for ongoing support and consultations as your business evolves." },
  { id: 3, title: "Licensing Assistance: ", para: "Ensure your business meets all local, state, and federal licensing requirements. We provide the support needed to obtain the necessary licenses and permits." },
]

export const llc = "Limited Liability Company (LLC)"
export const corporation = "Corporation"
export const llcVsCorpo = "LLC vs. Corporation: Which Business Structure is Right for You?"
export const contactUs = "contact us"
export const llcLink = "/"
export const contactUsLink = "/contact-us"

export const checklist = [
  { id: 1, number: "01", title: "Idea and Research", para: "The first step is identifying your business idea. Choose a concept that aligns with your skills, passions, and market needs. Conduct thorough market research to analyze your target market, competitors, and industry trends. This will help you validate your idea and make informed decisions." },
  { id: 2, number: "02", title: "Business Plan", para: "Create a comprehensive business plan outlining your business goals, strategies, and financial projections. An executive summary should include your business concept, market analysis, organizational structure, and financial needs. A well-crafted business plan is essential for securing funding and guiding your operations." },
  {
    id: 3, number: "03", title: "Choose a Business Structure", para: (<>
      Decide between forming an <Link style={{ color: "blue" }} to={llcLink}>{llc}</Link> or <Link style={{ color: "blue" }} to={llcLink}>{corporation}</Link> Your choice should be based on your business needs, goals, and the level of personal liability you are willing to assume. For assistance in choosing the right type of business structure, you can find more information here: <Link style={{ color: "blue" }} to={llcLink}>{llcVsCorpo}</Link>
    </>)
  },
  { id: 4, number: "04", title: "Register Your Business", para: (<>Choose a unique business name that reflects your brand and complies with state regulations. Check for name availability to avoid issues, we do that for you. File the necessary paperwork with your state to legally register your business, such as Articles of Organization for an <Link style={{ color: "blue" }} to={llcLink}>{llc}</Link> or Articles of Incorporation for a <Link style={{ color: "blue" }} to={llcLink}>{corporation}</Link>. Oktobiz can handle the registration process for you</>) },
  { id: 5, number: "05", title: "Obtain Necessary Permits and Licenses", para: (<>Determine the licenses and permits required for your industry and location. Submit applications and ensure compliance with all regulatory requirements to operate legally. Most business require some type of licensing to start running. Oktobiz can help you navigate the permit and licensing process. Please <Link style={{ color: "blue" }} to={contactUsLink}>{contactUs}</Link> to obtain all necessary licensing for your business</>) },
  { id: 6, number: "06", title: "Get an EIN", para: "Apply for an Employer Identification Number (EIN) from the IRS. This is crucial for tax purposes, opening a business bank account, and hiring employees. Oktobiz can assist you in obtaining your EIN after having your business formed with the state." },
  { id: 7, number: "07", title: "Open a Business Bank Account", para: "Select a bank that offers favorable terms and services tailored to your business needs. Open a business checking account to keep your personal and business finances separate, which is essential for tax and legal purposes." },
  { id: 8, number: "08", title: "Set Up Accounting and Record-Keeping", para: "Implement an accounting system to track income, expenses, and financial performance. Consider using accounting software like QuickBooks or Xero. Maintain accurate and up-to-date records for tax reporting, financial analysis, and compliance." },
  { id: 9, number: "09", title: "Develop Your Brand", para: "Design a logo and develop branding materials that reflect your business identity and values" },
]

export const businessStrucutre = [
  {
    id: 1, title: "Limited Liability Company (LLC)", options: [
      { id: 1, subheading: "Formation: ", para: "Forming an LLC is generally easier and less formal than forming a corporation. It requires filing Articles of Organization with the state." },
      { id: 2, subheading: "Ownership: ", para: "An LLC is owned by members, who can be individuals or other businesses. There's no limit on the number of members." },
      { id: 3, subheading: "Management: ", para: "An LLC can be managed by its members (owners) or appointed managers. This flexibility allows for a more tailored management structure." },
      { id: 4, subheading: "Liability Protection: ", para: "An LLC provides personal liability protection, meaning members are not personally liable for business debts or liabilities." },
      { id: 5, subheading: "Taxation: ", para: "LLCs offer pass-through taxation (S-Corporation) by default, where profits and losses are reported on members' personal tax returns, avoiding the double taxation seen in corporations." },
      { id: 6, subheading: "Flexibility: ", para: "LLCs offer a flexible management structure with fewer compliance requirements, making them a popular choice for small to medium-sized businesses." },
    ]
  },
  {
    id: 2, title: "Corporation", options: [
      { id: 1, subheading: "Formation: ", para: "Forming a corporation is more complex and requires filing Articles of Incorporation, creating bylaws, and holding an initial board meeting." },
      { id: 2, subheading: "Ownership: ", para: "A corporation is owned by shareholders. There can be an unlimited number of shareholders, which makes it easier to raise capital." },
      { id: 3, subheading: "Management: ", para: "Corporations are managed by a board of directors elected by shareholders. The board appoints officers to handle day-to-day operations." },
      { id: 4, subheading: "Liability Protection: ", para: "Corporations provide strong personal liability protection for shareholders, protecting their personal assets from business debts and liabilities." },
      { id: 5, subheading: "Taxation: ", para: "Corporations are subject to double taxation. The corporation pays taxes on its profits, and shareholders pay taxes on dividends received. However, electing S-Corporation status can avoid double taxation." },
      { id: 6, subheading: "Compliance: ", para: "Corporations have more formalities and compliance requirements, such as holding annual meetings, maintaining detailed records, and filing annual reports." },
    ]
  },
  {
    id: 3, title: "Key Considerations", options: [
      { id: 1, subheading: "Business Complexity: ", para: "LLCs are ideal for simpler business operations, while corporations are suited for businesses planning to attract investors or go public." },
      { id: 2, subheading: "Tax Implications: ", para: "Evaluate the tax benefits and implications of each structure to determine the best fit for your financial goals." },
      { id: 3, subheading: "Growth and Investment: ", para: "Corporations are generally better for businesses seeking significant investment and planning for future growth." },
    ]
  }
]

export const corporationOptions = [
  {
    id: 1, title: "C-Corporation (C-Corp)", options: [
      { id: 1, subheading: "Formation: ", para: "Forming a C-Corp requires filing Articles of Incorporation with the state and adhering to corporate formalities such as creating bylaws and holding initial board meetings." },
      { id: 2, subheading: "Taxation: ", para: "C-Corps are subject to double taxation. The corporation pays taxes on its profits, and shareholders also pay taxes on dividends received. This can result in higher overall tax liability." },
      { id: 3, subheading: "Ownership: ", para: "C-Corps can have an unlimited number of shareholders, including foreign investors. They can issue multiple classes of stock, which provides flexibility in raising capital." },
      { id: 4, subheading: "Flexibility: ", para: "C-Corps are ideal for businesses looking to attract venture capital or go public. The ability to issue multiple classes of stock and attract a large number of investors is a significant advantage." },
      { id: 5, subheading: "Regulations: ", para: "C-Corps face more regulatory requirements and must comply with detailed record-keeping, reporting, and compliance obligations." },
    ]
  },
  {
    id: 2, title: "S-Corporation (S-Corp)", options: [
      { id: 1, subheading: "Formation: ", para: "S-Corps are formed similarly to C-Corps but must file with the IRS to elect S-Corp status. This election allows the corporation to be taxed under Subchapter S of the Internal Revenue Code." },
      { id: 2, subheading: "Taxation: ", para: "S-Corps avoid double taxation. Profits and losses pass through to shareholders' personal tax returns, allowing income to be taxed at individual rates. This can result in significant tax savings." },
      { id: 3, subheading: "Ownership: ", para: "S-Corps are limited to 100 shareholders, all of whom must be U.S. citizens or residents. S-Corps can only issue one class of stock, which can limit flexibility in raising capital." },
      { id: 4, subheading: "Flexibility: ", para: "S-Corps have more restrictions on ownership and stock issuance compared to C-Corps. However, they offer the benefit of pass-through taxation and can still provide liability protection." },
      { id: 5, subheading: "Regulations: ", para: "S-Corps have fewer regulatory requirements than C-Corps but must meet specific IRS criteria to maintain their status." },
    ]
  },
  {
    id: 3, title: "Key Considerations", options: [
      { id: 1, subheading: "Tax Benefits: ", para: "S-Corps offer tax savings through pass-through taxation but come with ownership and stock issuance restrictions." },
      { id: 2, subheading: "Growth Potential: ", para: "C-Corps are better suited for companies planning significant growth and seeking various types of investors." },
      { id: 3, subheading: "Operational Complexity: ", para: "Consider the compliance and reporting requirements of each structure and choose the one that aligns with your business needs and goals." },
    ]
  }
]

export const employerIdentificationNumber = [
  {
    id: 1, title: "What is an EIN?", options: [
      { id: 1, subheading: "Definition: ", para: "An EIN, also known as a Federal Tax Identification Number, is used to identify a business entity. It functions similarly to a Social Security Number (SSN) for individuals." },
      { id: 2, subheading: "Purpose: ", para: "It is used for various tax-related purposes, including filing tax returns, opening business bank accounts, and hiring employees." }
    ]
  },
  {
    id: 2, title: "When Do You Need an EIN?", options: [
      { id: 1, subheading: "Starting a New Business: ", para: "Any business entity, including LLCs, Corporations, Partnerships, and Sole Proprietorships, typically needs an EIN." },
      { id: 2, subheading: "Hiring Employees: ", para: "If you plan to hire employees, you must have an EIN to manage payroll and file employment taxes." },
      { id: 3, subheading: "Banking: ", para: "An EIN is required to open a business bank account and establish business credit." },
      { id: 4, subheading: "Compliance: ", para: "Certain licenses, permits, and business registrations require an EIN." },
    ]
  },
  {
    id: 3, title: "Benefits of Having an EIN", options: [
      { id: 1, subheading: "Tax Reporting: ", para: "Simplifies tax reporting and ensures compliance with federal tax regulations." },
      { id: 2, subheading: "Business Transactions: ", para: "Essential for conducting business activities such as opening bank accounts, applying for loans, and entering into contracts." },
      { id: 3, subheading: "Credibility: ", para: "Having an EIN enhances your business's credibility and professionalism in the eyes of customers and vendors." },
    ]
  }
]

export const impForYourBusiness = [
  { id: 1, title: "What is BOI?", para: "BOI refers to information about the individuals who own or control a company. This includes personal details such as names, addresses, dates of birth, and ownership percentages. The purpose of BOI filing is to prevent money laundering, terrorist financing, and other illicit activities by ensuring transparency in business ownership." },
  { id: 2, title: "Who Needs to File BOI?", para: "Corporations, LLCs, and other business entities are typically required to file BOI. Certain entities, such as publicly traded companies, may be exempt from BOI filing requirements." },
  { id: 3, title: "Benefits of BOI Compliance", para: "Compliance with BOI regulations help avoid penalties($500 every day it is late) and legal issues. It also enhances transparency and builds trust with stakeholders, including customers, investors, and regulators. Maintaining accurate ownership records reduces the risk of being involved in illegal activities." },
]





